import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-boolean-toggle-filter',
  templateUrl: './boolean-toggle-filter.component.html',
  styleUrls: ['./boolean-toggle-filter.component.scss']
})

export class BooleanToggleFilterComponent {

  @Input() active: boolean = true;
  @Input() booleanToggleFilterText: string;
  @Output() booleanToggleFilterChangedEvent = new EventEmitter();

  booleanToggleFilterValue: boolean;

  constructor() {
  }

  booleanToggleFilterChanged() {
    this.booleanToggleFilterChangedEvent.emit(this.booleanToggleFilterValue);
  }
}
